// removed by extract-text-webpack-plugin
module.exports = {"widget":"c-Widget__widget","klarnaCheckout":"c-Widget__klarnaCheckout"};